import { CommonModule, NgIf } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroCheckCircle, heroPencil, heroTrash, heroXMark } from '@ng-icons/heroicons/outline'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { NumericTextBoxComponent, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { RepSubscription } from '../../../../models/repEditorModels'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-subscription',
    templateUrl: './rep-editor-subscription.component.html',
    styleUrls: ['./rep-editor-subscription.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        DropDownListComponent,
        FormsModule,
        ReactiveFormsModule,
        NumericTextBoxComponent,
        TextBoxDirective,
        CommandColumnComponent,
        CellTemplateDirective,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        NgIcon,
        AdminOnlyDirective
    ],
    providers: [
        provideIcons({ heroPencil, heroTrash, heroCheckCircle, heroXMark })
    ]
})
export class RepEditorSubscriptionComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  @Input() override repId: number = 0
  repSubscription: RepSubscription[]
  subscriptions: any[]
  activeSubscriptions = this.repState.getActiveSubscriptions()

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
      console.log('tested' + JSON.stringify('test'))
    this.checkGridState()

    if (!this.repState.repSubscriptions) {
      this.initGrid()
    }

    if (!this.repState.subscriptions) {
      this.typesService.getSubscription().subscribe((response) => {
        console.log('tested' + JSON.stringify(response))
        this.repState.subscriptions = response
      })
    }
  }

  initGrid() {
    this.clientService
      .getRepSubscriptionForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repSubscriptions = response.map(
          (rs) => new RepSubscription(rs),
        )
      })
  }

  public addHandler({ sender }) {
    const newRepSubscription = new RepSubscription(null)
    newRepSubscription.repID = this.repId
    newRepSubscription.active = true
    this.addHandlerShared({ sender }, newRepSubscription)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const repSubscription = new RepSubscription(formGroup.value)
    this.clientService
      .submitRepSubscriptionUpdate(repSubscription)
      .subscribe(() => {
        sender.closeRow(rowIndex)
        this.initGrid()
      })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new RepSubscription(dataItem)
    itemToRemove.active = false
    this.clientService
      .submitRepSubscriptionUpdate(itemToRemove)
      .subscribe(() => {
        this.initGrid()
      })
  }

  public createFormGroup(repSubscription: RepSubscription): UntypedFormGroup {
    return this.formBuilder.group({
      repSubscriptionID: repSubscription.repSubscriptionID,
      repID: repSubscription.repID,
      subscriptionID: [repSubscription.subscriptionID, Validators.required],
      subscriptionDescription: repSubscription.subscriptionDescription,
      cost: [repSubscription.cost, Validators.required],
      userID: repSubscription.userID,
      active: repSubscription.active,
    })
  }
}
